import { httpClient } from '@/services/http/httpClient'

export type GetMyCountProjectsResponse = {
  all: number
  myProjectsResponsible: number
  myProjectsMember: number
}

export async function getMyCountProjects(): Promise<GetMyCountProjectsResponse> {
  const { data } = await httpClient.get(
    '/projects/portfolio-projects/my-projects/count',
  )
  return data
}
